var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('draggable',{staticClass:"d-flex",attrs:{"list":_vm.amaActivites},on:{"end":_vm.movingSections}},_vm._l((_vm.amaActivites),function(section,index){return _c('Section',{key:section.id,attrs:{"title":section.title,"tasks":section.tasks,"sectionIndex":index},on:{"change":_vm.movingTasks}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }